import { render, staticRenderFns } from "./DataSwitch.vue?vue&type=template&id=a2820074&"
import script from "./DataSwitch.vue?vue&type=script&lang=ts&"
export * from "./DataSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports